import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-loading-indicator',
    templateUrl: './loading-indicator.component.html',
    styleUrls: ['./loading-indicator.component.scss'],
    standalone: false
})
export class LoadingIndicatorComponent implements OnInit {
    @Input() zIndex = 9999;
    @Input() size = '150px';
    @Input() delay = 200;
    @Input() backgroundColor = 'standard';
    isVisible = false;

    ngOnInit(): void {
        setTimeout(() => (this.isVisible = true), this.delay);
    }
}
